type UserStatus = 'ACTIVE' | 'INACTIVE' | 'SUSPENDED' | 'LOCKED' | 'ARCHIVED' | 'DELETED';

interface UserStatusBadgeProps {
  status: UserStatus;
  showIcon?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export default function UserStatusBadge({ status, showIcon = true, size = 'md' }: UserStatusBadgeProps) {
  const getStatusConfig = (status: UserStatus) => {
    switch (status) {
      case 'ACTIVE':
        return {
          label: 'Active',
          icon: '🟢',
          bgColor: 'bg-green-100',
          textColor: 'text-green-800',
          borderColor: 'border-green-200'
        };
      case 'INACTIVE':
        return {
          label: 'Inactive',
          icon: '🟡',
          bgColor: 'bg-yellow-100',
          textColor: 'text-yellow-800',
          borderColor: 'border-yellow-200'
        };
      case 'SUSPENDED':
        return {
          label: 'Suspended',
          icon: '🔴',
          bgColor: 'bg-red-100',
          textColor: 'text-red-800',
          borderColor: 'border-red-200'
        };
      case 'LOCKED':
        return {
          label: 'Locked',
          icon: '🔒',
          bgColor: 'bg-orange-100',
          textColor: 'text-orange-800',
          borderColor: 'border-orange-200'
        };
      case 'ARCHIVED':
        return {
          label: 'Archived',
          icon: '📦',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-800',
          borderColor: 'border-gray-200'
        };
      case 'DELETED':
        return {
          label: 'Deleted',
          icon: '🗑️',
          bgColor: 'bg-gray-200',
          textColor: 'text-gray-600',
          borderColor: 'border-gray-300'
        };
      default:
        return {
          label: status,
          icon: '❓',
          bgColor: 'bg-gray-100',
          textColor: 'text-gray-600',
          borderColor: 'border-gray-200'
        };
    }
  };

  const config = getStatusConfig(status);

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base'
  };

  return (
    <span
      className={`inline-flex items-center gap-1 ${config.bgColor} ${config.textColor} border ${config.borderColor} rounded-full font-semibold ${sizeClasses[size]}`}
    >
      {showIcon && <span>{config.icon}</span>}
      <span>{config.label}</span>
    </span>
  );
}
